let initialState;
try {
	initialState = {
		loggedIn: (!!localStorage.getItem('user') && !!localStorage.getItem('pass')),
		user: localStorage.getItem('user'),
		pass: localStorage.getItem('pass')
	};
}
catch (err) {
	initialState = { loggedIn: false };
}

export default function authReducer(state = initialState, action) {
	switch (action.type) {
		case 'LOGIN_REQUEST':
			return {
				loggingIn: true
			};
		case 'LOGIN_SUCCESS':
			return {
				loggedIn: true,
				user: localStorage.getItem('user'),
				pass: localStorage.getItem('pass')
			};
		case 'LOGIN_FAILURE':
		case 'LOGOUT':
			return {};
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/authReducer.js